import { createInjectionKey as o } from "./highrise529.mjs";
const e = o("n-modal-body"), d = o("n-modal-provider"), t = o("n-modal");
export {
  e as modalBodyInjectionKey,
  t as modalInjectionKey,
  d as modalProviderInjectionKey
};
